import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { get } from '@wp-g2/create-styles';
import { DARK_MODE_COLORS, DARK_MODE_RGBA_COLORS } from './tokens';

var DARK_MODE_PROPS = _objectSpread(_objectSpread(_objectSpread({}, DARK_MODE_COLORS), DARK_MODE_RGBA_COLORS), {}, {
  buttonPrimaryTextColorActive: get('controlPrimaryTextColorActive'),
  buttonControlActiveStateTextColor: get('colorTextInverted'),
  colorBodyBackground: '#18191A',
  colorDivider: 'rgba(255, 255, 255, 0.1)',
  colorScrollbarThumb: 'rgba(255, 255, 255, 0.2)',
  colorScrollbarThumbHover: 'rgba(255, 255, 255, 0.5)',
  colorScrollbarTrack: 'rgba(0, 0, 0, 0.04)',
  colorText: '#E4E6EB',
  colorTextInverted: '#050505',
  colorTextHeading: '#ffffff',
  controlBackgroundColor: get('colorBodyBackground'),
  controlBackgroundColorHover: 'rgba(255, 255, 255, 0.3)',
  controlBackgroundBrightColor: 'rgba(255, 255, 255, 0.08)',
  controlBackgroundDimColor: 'rgba(255, 255, 255, 0.2)',
  controlBorderSubtleColor: 'rgba(255, 255, 255, 0.5)',
  controlPrimaryTextColorActive: get('black'),
  controlPrimaryTextColor: get('white'),
  controlSurfaceColor: 'rgba(255, 255, 255, 0.3)',
  controlTextActiveColor: get('white'),
  surfaceBackgroundColor: get('colorBodyBackground'),
  surfaceBackgroundSubtleColor: '#151515',
  surfaceBackgroundTintColor: '#252525',
  surfaceBackgroundTertiaryColor: '#000',
  surfaceBorderColor: 'rgba(255, 255, 255, 0.1)',
  surfaceBorderBoldColor: 'rgba(255, 255, 255, 0.15)',
  surfaceBorderSubtleColor: 'rgba(255, 255, 255, 0.05)',
  surfaceColor: '#292929'
});

export var DARK_THEME = _objectSpread({}, DARK_MODE_PROPS);
export var darkModeConfig = DARK_THEME;